import { Text, View, Image } from 'components';
import BuyTopModal from '../../components/buyTopModal';
// import Modal from 'react-modal';
import Base, { Config } from 'components/megatron/Base';
import React from 'react';
import { history } from 'modules/navigator';
import cx from 'classnames';
import styles from './index.module.scss';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';


interface State {
  visible: boolean
  jobID?: number
}

export default class EmployToTop extends Base {
  public config: Config = {
    navigationBarTitleText: '招聘全国置顶'
  };

  public state: State = {
    visible: false
  }

  public didMount(){
    
  }

  public render() {
    const { visible, jobID } = this.state
    return (
      <View className={styles.container}>
        <ToastContainer className={styles.ToastContainer}/>
        <View className={styles.page}>
            <View className={styles.top}>
              <Text className={cx(styles.h2, styles.sm)}>招聘显示在网站首页最上面</Text>
              <Text className={styles.p}>600倍曝光量，最快3分钟找到驾驶员</Text>
              <Text className={styles.p}>每天限量<Text className={styles.span}>10</Text>个置顶位，<Text className={styles.span}>先到先得</Text></Text>
            </View>
          
          <View className={styles.main}>
            <Image 
              className={styles.img} 
              src={this.assets.megatron.employToTop} 
            />
          </View>
          <View className={styles.bottom}>
            
            <button className={cx(styles.btn, styles.blue)} onClick={this.preflightOpenPinDialog}>
              <Text className={styles.p}>立即置顶</Text>
            </button>
          </View>
          
          <BuyTopModal visible={visible} jid={jobID} onClose={this.toggleVisible.bind(null,false)} />

        </View>

      </View>
    );
  }

  private toggleVisible = (bol:boolean = true) => {
    this.setState({
      visible: bol
    })
  }

  private handleBack = () => {
    this.navigator.back()
  }

  

  private preflightOpenPinDialog = async () => {
    // this.toggleVisible()

    const { body } = await this.apiClient.base.manage()
    let jobs = body  
    
    if (jobs.length === 0) {
      // 没有招聘，去发布
      
      toast.error('请先前往小程序发布招聘！', {
        position: toast.POSITION.TOP_RIGHT,
        autoClose: 1500,
        closeButton: false,
      })
      
    } else if (jobs.length === 1) {
      // 有一个，去推荐
      this.setState({
        jobID: jobs[0].id
      })
      this.toggleVisible()
    } else {
      history.push('/payment/selectEmploy')
    }
  }
  


}
